import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
} from 'react-bootstrap';
import { renderField, required, email } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => (
  <InputGroup>
    <FormControl
      {...input}
      type={type}
      label={label}
      placeholder={placeholder}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const RegisterAgencyForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, email, agencyName } = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          name="email"
          type="input"
          component={renderBootstrapField}
          label="email"
          placeholder="Email"
          validate={[required]}
        />
        <Field
          name="name"
          type="input"
          component={renderBootstrapField}
          label="Name"
          placeholder="Your name"
        />
        <Field
          name="agency_name"
          type="input"
          component={renderBootstrapField}
          label="Agency Name"
          placeholder="Agency Name"
          validate={[required]}
        />
        <div>
          <Button
            disabled={pristine || submitting}
            bsStyle="default"
            type="submit"
          >
          Register
          </Button>
        </div>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'RegisterAgencyForm',
})(RegisterAgencyForm);



// WEBPACK FOOTER //
// src/routes/agency/components/RegisterAgencyForm.js